import { FatalError } from "@prismicio/editor-support/Error"
import { isRequestError } from "@prismicio/editor-support/Http"
import {
  Breadcrumbs,
  BrowserClient,
  Dedupe,
  defaultStackParser,
  getCurrentHub,
  GlobalHandlers,
  HttpContext,
  makeFetchTransport
} from "@sentry/react"

import { env } from "../env"
import { getRepositoryName } from "../routing"

export const createSentryClient = () => {
  const client = new BrowserClient({
    environment: env.PAGE_BUILDER_SENTRY_ENVIRONMENT,
    dsn: env.PAGE_BUILDER_SENTRY_DSN,
    tracesSampleRate: 0.01,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: [
      new Breadcrumbs(),
      new GlobalHandlers(),
      new Dedupe(),
      new HttpContext()
    ],
    beforeSend(event, hint) {
      if (!shouldSendError(hint.originalException)) return null

      event.tags ||= {}
      event.tags["repository"] = getRepositoryName()
      event.tags["commit"] = env.PRISMIC_GIT_COMMIT_HASH
      return event
    }
  })

  getCurrentHub().bindClient(client)
}

function shouldSendError(error: unknown) {
  // In general, we assume our HTTP endpoints are well configured in the frontend and any network error should be reported from the backend systems instead.
  // Also timeouts and connection error can be a user-land issue we should ignore.
  if (isRequestError(error)) return false

  // We throw a FatalError when the error can not be recovered from by clicking "try again".
  // There's nothing to report as this represents an expected/valid Page Builder control flow interruption.
  if (error instanceof FatalError) return false

  return true
}
